import isEmpty from "lodash/isEmpty.js"

const BASE_URL = `${process.env.BASE_URL_V2}`

export const actions = {
  async parserSources({}, params) {
    return this.$axios.$get(`${BASE_URL}/smm_parser/sources/`, { params: { ...params } });
  },
  async parserSource({}, id) {
    return this.$axios.$get(`${BASE_URL}/smm_parser/sources/${id}/`);
  },
  async parserCreateSource({}, payload) {
    return this.$axios.$post(`${BASE_URL}/smm_parser/sources/`, payload);
  },
  async parserDeleteSource({}, id) {
    return this.$axios.$delete(`${BASE_URL}/smm_parser/sources/${id}/`);
  },
  async parserDeleteManySources({ dispatch }, sourceIds = []) {
    return Promise.all(sourceIds.map((id) => dispatch('parserDeleteSource', id)));
  },
  async parserPosts({}, params) {
    return this.$axios.$get(`${BASE_URL}/smm_parser/posts/`, { params: { ...params } });
  },
  async parserDeletePost({}, id) {
    return this.$axios.$delete(`${BASE_URL}/smm_parser/posts/${id}/`);
  },
  async parserDeleteManyPosts({ dispatch }, postIds = []) {
    return Promise.all(postIds.map((id) => dispatch('parserDeletePost', id)));
  },
  async sendAiSenders({}, params) {
    return this.$axios.$get(`${BASE_URL}/smm_send_ai/accounts/`, { params: { ...params } });
  },
  async sendAiDeleteSender({}, id) {
    return this.$axios.$delete(`${BASE_URL}/smm_send_ai/accounts/${id}/`);
  },
  async sendAiProjects({}, params) {
    return this.$axios.$get(`${BASE_URL}/smm_send_ai/projects/`, { params: { ...params } });
  },
  async sendAiProject({}, id) {
    return this.$axios.$get(`${BASE_URL}/smm_send_ai/projects/${id}/`);
  },
  async sendAiCreateProject({}, payload) {
    return this.$axios.$post(`${BASE_URL}/smm_send_ai/projects/`, payload);
  },
  // async sendAiUpdateProject({}, { id, payload }) {
  //   return this.$axios.$patch(`${BASE_URL}/smm_send_ai/projects/${id}/`, payload);
  // },
  async sendAiDeleteProject({}, id) {
    return this.$axios.$delete(`${BASE_URL}/smm_send_ai/projects/${id}/`);
  },
  async sendAiRoles({}, params = {}) {
    return this.$axios.$get(`${BASE_URL}/smm_send_ai/roles/`, { params: { ...params } });
  },
  // Admin AI assistant (explicit names)
  async assistantAiAdminProjects({}, params = {}) {
    return this.$axios.$get(`${BASE_URL}/admin/ai_assistant/projects/`, { params: { ...params } });
  },
  async assistantAiAdminProject({}, id) {
    return this.$axios.$get(`${BASE_URL}/admin/ai_assistant/projects/${id}/`);
  },
  async assistantAiAdminCreateProject({}, payload) {
    return this.$axios.$post(`${BASE_URL}/admin/ai_assistant/projects/`, payload);
  },
  async assistantAiAdminUpdateProject({}, { id, payload }) {
    return this.$axios.$post(`${BASE_URL}/admin/ai_assistant/projects/`, { id, ...payload });
  },
  async assistantAiAdminDeleteProject({}, id) {
    return this.$axios.$delete(`${BASE_URL}/admin/ai_assistant/projects/${id}/`);
  },
  async assistantAiAdminDialogs({}, params = {}) {
    return this.$axios.$get(`${BASE_URL}/admin/ai_assistant/dialogs/`, { params: { ...params } });
  },
  async assistantAiAdminDialog({}, id) {
    return this.$axios.$get(`${BASE_URL}/admin/ai_assistant/dialogs/${id}/`);
  },
  async assistantAiAdminDeleteDialog({}, id) {
    return this.$axios.$delete(`${BASE_URL}/admin/ai_assistant/dialogs/${id}/`);
  },
  async assistantAiAdminDialogMessages({}, id) {
    return this.$axios.$get(`${BASE_URL}/admin/ai_assistant/dialogs/${id}/messages/`);
  },
  async assistantAiAdminDialogMessageDebugContent({}, { dialogId, messageId }) {
    return this.$axios.$get(
      `${BASE_URL}/debug/ai_assistant/dialogs/${dialogId}/messages/${messageId}/debug_llm_content/`
    );
  },
  async assistantAiPrivateProjects({}, params = {}) {
    return this.$axios.$get(`${BASE_URL}/private/ai_assistant/projects/`, { params: { ...params } });
  },
  async assistantAiPrivateDialogs({}, params = {}) {
    return this.$axios.$get(`${BASE_URL}/private/ai_assistant/dialogs/`, { params: { ...params } });
  },
  async assistantAiPrivateDialog({}, id) {
    return this.$axios.$get(`${BASE_URL}/private/ai_assistant/dialogs/${id}/`);
  },
  async assistantAiPrivateSetDialogTheme({}, { dialogId, themeId }) {
    return this.$axios.$post(`${BASE_URL}/private/ai_assistant/dialogs/${dialogId}/theme/${themeId}/`);
  },
  async assistantAiPrivateCreateDialog({}, payload) {
    return this.$axios.$post(`${BASE_URL}/private/ai_assistant/dialogs/create/`, payload);
  },
  async assistantAiPrivateDialogMessages({}, id) {
    return this.$axios.$get(`${BASE_URL}/private/ai_assistant/dialogs/${id}/messages/`);
  },
  async assistantAiPrivatePostDialogMessage({}, { id, payload }) {
    return this.$axios.$post(`${BASE_URL}/private/ai_assistant/dialogs/${id}/messages/`, payload);
  },
  async assistantAiPrivateObjectXml({}, idOrSlug) {
    return this.$axios.$get(
      `${BASE_URL}/misc/ai_assistant/object/${encodeURIComponent(idOrSlug)}/xml/`,
      { responseType: 'text', transformResponse: [(data) => data] }
    );
  },
  async assistantAiPrivateMaterialXml({}, idOrSlug) {
    return this.$axios.$get(
      `${BASE_URL}/misc/ai_assistant/material/${encodeURIComponent(idOrSlug)}/xml/`,
      { responseType: 'text', transformResponse: [(data) => data] }
    );
  },
  async assistantAiPrivateImagesOptions() {
    return this.$axios.$get(`${BASE_URL}/private/ai_assistant/images/options/`);
  },
  async assistantAiPrivateImagesGenerate({}, payload) {
    return this.$axios.$post(`${BASE_URL}/private/ai_assistant/images/generate/`, payload);
  },
  async assistantAiPrivateDeleteDialog({}, id) {
    return this.$axios.$delete(`${BASE_URL}/private/ai_assistant/dialogs/${id}/`);
  },
}
